module.exports = {
          srcSet: __webpack_public_path__ + "2b3dc462fb467da5505166c8f35ec235-61.png"+" 61w",
          images:[ {path: __webpack_public_path__ + "2b3dc462fb467da5505166c8f35ec235-61.png",width: 61,height: 13}],
          src: __webpack_public_path__ + "2b3dc462fb467da5505166c8f35ec235-61.png",
          toString:function(){return __webpack_public_path__ + "2b3dc462fb467da5505166c8f35ec235-61.png"},
          
          width: 61,
          height: 13
        }